import { FormFieldSchema, IInputFieldProps } from "@generation/core";
import * as React from "react";
import { useFieldRenderContext } from "../Context/FieldRenderContextProvider";
import { convertCallbackToValidationArray } from "../Utils/validate";
import { IsRequiredValidation } from "../Validations/IsRequiredValidation";
import { useErrorMessage } from "../Validations/useErrorMessage";
import "./withRenderFieldHoc.scss";

export function withRenderFieldHoc<T extends IInputFieldProps<FormFieldSchema>>(
  Component: React.FunctionComponent<T>
) {
  const result = (props: T) => {
    const renderContext = useFieldRenderContext();

    if (!renderContext) {
      return <></>;
    }

    const validations = convertCallbackToValidationArray(props.field.validate);

    const isRequired =
      validations?.find((item) => item instanceof IsRequiredValidation) !== undefined ? "*" : "";

    const labelText = `${props.field.label ?? ""} ${isRequired}`;
    const error = useErrorMessage(props.name, props.field, validations ?? []);

    return (
      <renderContext.default
        field={props.field}
        name={props.name}
        Component={Component}
        componentProps={props}
        error={error}
        label={labelText}
        value={props.value}
      />
    );
  };

  result.displayName = "WithRenderFieldHoc";

  return result;
}
